import { APP_BASE_URL } from "constants/endpoints";

export const INTERNAL_PATHS = {
  HOME: "/",
  SECRET_HOME: "/secret-home-page",
  BUY_GIFT_CARDS: "/buy-gift-cards",
  BRAND_DETAILS: "/buy-[A-Za-z0-9-]+-gift-cards",
  SELL_GIFT_CARDS: "/sell-gift-cards",
  SELL_BRAND_GIFT_CARDS: "/sell-[A-Za-z0-9-]+-gift-cards",
  USER_SIGN_UP: "/user/sign_up",
  USER_LOG_IN: "/user/sign_in",
  USER_LOGOUT: "/user/logout",
  MY_REFERRALS: "/my_referrals",
  GET_THE_APP: "/mobile",
  ABOUT: "/about-us",
  PARTNER_PROGRAM: "/partnerships",
  BRAND_RESTRICTIONS: "/donotbuy",
  GUARANTEE: "/guarantee",
  FTC_DISCLOSURE: "/ftc-disclosure",
  SHOP_LOCAL: "/shop-local",
  HOW_IT_WORKS: "/how-it-works",
  SHOP_CLEARANCE: "/shop/clearance",
  SHOP_CASHBACK: "/shop/cash-back",
  REFERRAL_PROGRAM: "/refer-a-friend",
  GIFT_CARD_BALANCE: "/gift-card-balance",
  GIFT_CARD_BALANCE_CHECK: "/gift-card-balance-check",
  SHIPPING_POLICY: "/shipping-policy",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms",
  RAISE_CASH_TERMS: "/raise-cash-terms",
  PRESS: "/press",
  CAREERS: "/careers",
  CART: "/cart",
  PRIMARY_CHECKOUT: "/checkout",
  SECONDARY_CHECKOUT: "/secondary-checkout",
  ORDERS: "/orders/:orderId",
  BRAND_ALERTS: "/brand_alerts",
  MY_ACCOUNT: "/account",
  NOT_FOUND: "/404",
  RESET_PASSWORD: "/user/password/new",
  CHANGE_PASSWORD: "/user/password/edit",
  MY_ORDERS: "/my_orders",
  MY_LISTINGS: "/my_listings",
  MY_SCHEDULED_GIFTS: "/my_scheduled_gifts",
  MY_RAISE_CASH: "/my_raise_cash",
  SETTINGS: "/account/billing_shipping",
  SHIPMENTS: "/shipments",
  SHOP: "/shop/:name",
  DEVICE_VERIFICATION: "/security_verifications/device_verifications",
  DEVICE_VERIFICATION_NEW: "/security_verifications/device_verifications/new",
  PLAYGROUND: "/playground",
  APPLE_AUTH_CALLBACK: "/user/auth/apple/callback"
};

export const EXTERNAL_LINKS = {
  MARKETPLACE_ZENDESK: "https://help.raise.com/hc/en-us",
  MARKETPLACE_ZENDESK_NEW_REQUEST:
    "https://help.raise.com/hc/en-us/requests/new",
  FACEBOOK: "https://www.facebook.com/RaiseMarketplace",
  TWITTER: "https://twitter.com/RaiseMarket",
  INSTAGRAM: "https://www.instagram.com/raise",
  YOUTUBE: "https://www.youtube.com/user/RaiseGiftCards",
  PINTEREST: "https://www.pinterest.com/raise/",
  DOWNLOAD_APP_STORE:
    "https://itunes.apple.com/us/app/raise-discounted-gift-cards/id922643195?mt=8",
  DOWNLOAD_PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.raise.andraise&amp;hl=en",
  DOWNLOAD_MEDIA_KIT:
    "https://s3.amazonaws.com/assets.coupontrade.com/assets/media-assets/Media_Kit.zip",
  FACEBOOK_SHARE: `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${encodeURIComponent(
    `${APP_BASE_URL}/buy-gift-cards`
  )}&display=popup&ref=plugin&src=share_button`,
  TWITTER_SHARE:
    "https://twitter.com/share?url=https://raise.com/buy-gift-cards&text=Buy Gift Cards at Raise.com via @RaiseMarket&hashtags=giftcard",
  GOOGLE_PRIVACY_PARTNERS: "https://www.google.com/policies/privacy/partners",
  GOOGLE_ANALYTICS_DISABLE: "https://tools.google.com/dlpage/gaoptout",
  DO_NOT_TRACK_INFO: "http://www.allaboutdnt.com",
  RAISE_CCPA_NOTICE: `${APP_BASE_URL}/assets/raise-ccpa-notice-12-31-2019.pdf`,
  SALESFORCE_HELP: "https://webto.salesforce.com/servlet/servlet.WebToLead",
  RAISE_RISK_SDK: `${APP_BASE_URL}/static/risk/assets/sdk/raise-risk-sdk-latest.min.js`
};
